module.exports = __webpack_public_path__ + "img/new-videosnap.8b5adbfd.svg";